"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwipeableViews = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _reactSwipeableViews = _interopRequireDefault(require("react-swipeable-views"));

var StyledSwipeableViews = (0, _styledBase.default)(_reactSwipeableViews.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n\n  & > div {\n    height: 100%;\n  }\n"])));
exports.SwipeableViews = StyledSwipeableViews;